import { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Link } from "@mui/material";
import { Home as HomeIcon } from "@mui/icons-material";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

interface CicdBreadcrumbsProps {
  scope: SpaceOrWorkspaceScope;
  trail: ReactNode[];
}

export const CicdBreadcrumbs = ({
  scope,
  trail = [],
}: CicdBreadcrumbsProps) => {
  const breadcrumbs = [
    <Link
      key="/space/overview"
      component={RouterLink}
      to={`/space/overview?${scope.params}`}
      display="flex"
    >
      <HomeIcon fontSize="inherit" />
    </Link>,
    ...trail,
  ];

  return (
    <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
      {breadcrumbs}
    </Breadcrumbs>
  );
};
